export const providerOnboardingQueryKeys = {
  all: ["provider-onboarding"] as const,
  applicationInfo: (userId: string, providerType: string) =>
    [...providerOnboardingQueryKeys.all, "application-info", userId, providerType] as const,
  fees: (userId: string, applicationId: string, providerType: string) =>
    [...providerOnboardingQueryKeys.all, "fees", userId, applicationId, providerType] as const,
  termsAndConditions: (userId: string, applicationId: string, providerType: string) =>
    [...providerOnboardingQueryKeys.all, "terms-and-conditions", userId, applicationId, providerType] as const,
  beneficialOwners: (userId: string, applicationId: string, providerType: string) =>
    [...providerOnboardingQueryKeys.all, "beneficial-owners", userId, applicationId, providerType] as const,
  status: (userId: string, applicationId: string, providerType: string) =>
    [...providerOnboardingQueryKeys.all, "status", userId, applicationId, providerType] as const,
  documents: (userId: string, applicationId: string, providerType: string) =>
    [...providerOnboardingQueryKeys.all, "documents", userId, applicationId, providerType] as const,
};

export default providerOnboardingQueryKeys;
